import { type OpenAPI } from 'openapi-types';
import { type NoRefParam } from './types';

// Type guard function to filter out Param references
export function isNotParamReference(
  param: OpenAPI.Parameter
): param is NoRefParam {
  return 'in' in param;
}
